// test1081
(1081 && 0);
